"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constantsClasses_1 = require("../data/constantsClasses");
var constants_1 = require("../data/constants");
var StickyHeader = /** @class */ (function (_super) {
    __extends(StickyHeader, _super);
    function StickyHeader() {
        var _this = _super.call(this, constants_1.DATA_HEADER) || this;
        if (!_this.getElement())
            return _this;
        _this.scrollOffset = _this.getElement().offsetTop;
        //this.updateHeaderHeight();
        _this.initEventListeners();
        return _this;
    }
    StickyHeader.prototype.initEventListeners = function () {
        var _this = this;
        window.addEventListener('scroll', function () { _this.checkScrollPosition(); });
        //window.addEventListener('resize', () => {this.updateHeaderHeight()});
    };
    // Check the scroll position to set the is-sticky class to header
    StickyHeader.prototype.checkScrollPosition = function () {
        // if (window.scrollY == 0) {
        //   setTimeout(() => {
        //     this.updateHeaderHeight();
        //   }, 500)
        // }
        if (window.scrollY > this.scrollOffset) {
            this.getElement().classList.add(constantsClasses_1.CLASS_STICKY);
        }
        else {
            this.getElement().classList.remove(constantsClasses_1.CLASS_STICKY);
        }
    };
    return StickyHeader;
}(AbstractComponent_1.default));
exports.default = StickyHeader;
